export const fontCenturyGothic = {
	family: "Century Gothic",
	src: `url(https://st-static-files-cdn.s3-ap-southeast-2.amazonaws.com/fonts/Century+Gothic+400.ttf)`
};
